import React from 'react';
import withRedirectToLogin from './withRedirectToLogin';

const Page401Partner = () => {
   return (
      <div className='text-center absolute-center'>
         <h1 className='display-1 font-weight-bold'>401</h1>
         <p className='h1'>Unauthorized.</p>
         <p className='h2 font-weight-normal mt-3 mb-4'>
            You have no Partner access rights.
         </p>
      </div>
   );
};

export default withRedirectToLogin(Page401Partner);
